/* Swipe hint arrows, site-wide.
 *
 * On a phone the prev/next arrows are a HINT, not the control: the gesture is
 * the control. Leaving them parked on top of the image permanently covers the
 * thing the customer came to look at, so they announce themselves when a new
 * image lands and then get out of the way.
 *
 *   new image on screen -> visible 2s -> fade out over 1s -> stay gone
 *
 * They come back on the next slide change, so the affordance is never more
 * than one swipe away.
 *
 * TOUCH ONLY. On a desktop the arrows are the primary control and a mouse user
 * has no swipe to bring them back, so nothing here applies there.
 *
 * WHY THE CSS LIVES IN THIS FILE and not a stylesheet: the hidden state is the
 * CSS default. If the stylesheet loaded and this script did not, every arrow on
 * the site would be permanently invisible with no way to restore it. Shipping
 * them together means a failure to load leaves the arrows exactly as they are
 * today, which is the safe direction to fail in.
 */
(function () {
  if (window.__uaSwipeHints) return;
  window.__uaSwipeHints = true;

  var VISIBLE_MS = 2000; // how long they sit at full opacity
  var FADE_MS = 1000;    // how long they take to disappear

  var touch = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (!touch) return;

  var css =
    '.ua-swipe-hint .swiper-button-prev,' +
    '.ua-swipe-hint .swiper-button-next{' +
      'opacity:0;' +
      'transition:opacity ' + FADE_MS + 'ms ease;' +
      /* an invisible arrow must not keep eating taps meant for the image */
      'pointer-events:none;' +
    '}' +
    '.ua-swipe-hint.ua-hint-on .swiper-button-prev,' +
    '.ua-swipe-hint.ua-hint-on .swiper-button-next{' +
      'opacity:1;' +
      /* arrive promptly, leave slowly */
      'transition:opacity 150ms ease;' +
      'pointer-events:auto;' +
    '}' +
    '@media (prefers-reduced-motion: reduce){' +
      '.ua-swipe-hint .swiper-button-prev,' +
      '.ua-swipe-hint .swiper-button-next{transition:none}' +
    '}';

  var style = document.createElement('style');
  style.id = 'ua-swipe-hints-css';
  style.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(style);

  function hint(el) {
    if (!el) return;
    el.classList.add('ua-swipe-hint');
    clearTimeout(el.__uaHintTimer);
    // Drop and re-add so a swipe during the fade restarts the full 2s rather
    // than inheriting whatever was left of the previous one.
    el.classList.remove('ua-hint-on');
    void el.offsetWidth; // force the style change to land before re-adding
    el.classList.add('ua-hint-on');
    el.__uaHintTimer = setTimeout(function () {
      el.classList.remove('ua-hint-on');
    }, VISIBLE_MS);
  }

  /* Exposed so a component that shows an existing carousel again (the
     headliner lightbox reopening) can re-announce the arrows itself. Swiper
     fires no event for that: the slide never changed, the gallery did. */
  window.uaSwipeHint = hint;

  function attach(el) {
    if (el.__uaHintBound) return;
    var swiper = el.swiper;
    if (!swiper) return; // not initialised yet; a later scan will catch it
    if (!el.querySelector('.swiper-button-next, .swiper-button-prev')) return;
    el.__uaHintBound = true;
    swiper.on('slideChange', function () { hint(el); });
    hint(el); // the first image is also a new image on screen
  }

  function scan() {
    var els = document.querySelectorAll('.swiper');
    for (var i = 0; i < els.length; i++) attach(els[i]);
  }

  scan();

  /* Carousels appear late and at unpredictable times here: sections render
     client side, and the headliner lightbox does not build its Swiper until
     the first tap. Watching for Swiper's own "swiper-initialized" class is
     more reliable than guessing at load order. */
  var pending = null;
  var observer = new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(scan, 100);
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();
